import React, { FC, useState, useEffect } from 'react';
import { convertFromRaw, EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';

export interface RawProps {
  value: string;
}

export const Raw: FC<RawProps> = ({ value }) => {
  const color = '#0066FF';

  const [editorState, setEditorState] = useState<EditorState>(
    EditorState.createEmpty(),
  );

  useEffect(() => {
    let editorState: EditorState;

    try {
      editorState = EditorState.createWithContent(
        convertFromRaw(JSON.parse(value)),
      );
    } catch (error) {
      editorState = EditorState.createEmpty();
    }
    setEditorState(editorState);
  }, [value]);

  useEffect(() => {
    const root = document.querySelector('.DraftEditor-root');
    if (root === null) return;

    const observer = new MutationObserver(() => {
      const targetBlankLinkElements = document.querySelectorAll(
        '.DraftEditor-root a[target="_blank"]',
      );
      targetBlankLinkElements.forEach((element) => {
        element.setAttribute('rel', 'noopener noreferrer');
      });
    });

    observer.observe(root, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <div className="root">
        <Editor editorState={editorState} readOnly toolbarHidden />
      </div>
      <style jsx>{`
        .root :global(.rdw-editor-main) {
          padding: 0;
        }

        .root :global(p) {
          margin: 0;
        }

        /* リンクテキストのカラーが指定されていない場合は、サイトカラーを設定する */
        .root :global(a) {
          color: ${color};
        }

        .root :global(figure) {
          margin: 0;
        }

        .root :global(img) {
          display: inline-block;
          max-width: 100%;
        }

        .root {
          font-size: 14px;
        }
      `}</style>
    </>
  );
};
